import React from 'react';
import { InvoiceTotals, formatCurrency } from '../models/invoice';

interface Props {
    totals: InvoiceTotals;
}

const InvoiceSummary: React.FC<Props> = ({ totals }) => {
    return (
        <div style={styles.container}>
            <div style={styles.row}>
                <span style={styles.label}>Tarpinė suma:</span>
                <span>{formatCurrency(totals.subtotal)}</span>
            </div>
            <div style={styles.row}>
                <span style={styles.label}>PVM suma:</span>
                <span>{formatCurrency(totals.vatAmount)}</span>
            </div>
            <div style={{ ...styles.row, ...styles.total }}>
                <span style={styles.label}>Viso mokėti:</span>
                <span>{formatCurrency(totals.total)}</span>
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'block',
        maxWidth: '400px',
        marginLeft: 'auto',
        background: '#f9f9f9',
        padding: '20px',
        borderRadius: '8px',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px',
        fontSize: '1rem',
    },
    total: {
        marginTop: '15px',
        paddingTop: '15px',
        borderTop: '2px solid #ddd',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        color: '#0056b3',
    },
    label: {
        color: '#555',
    },
};

export default InvoiceSummary;
